<template>
  <el-form
    :model="editTaskForm"
    ref="editTaskForm"
    :rules="rules"
    label-width="120px"
    :hide-required-asterisk="false"
  >
    <el-row>
      <el-col :span="24">
        <el-form-item label="任务所属部门" prop="rwBmbh" key="2">
          <el-select
            v-model="editTaskForm.rwBmbh"
            filterable
            default-first-option
            style="width: 100%"
            placeholder="请选择任务所属部门"
            disabled
            @change="handleChangeTx(editTaskForm.rwBmbh)"
          >
            <el-option
              v-for="(item, index) in allBm"
              :key="index"
              :label="item.bmmc"
              :value="item.bmbh"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="任务所属条线" prop="rwTxlx" key="1">
          <el-select
            v-model="editTaskForm.rwTxlx"
            filterable
            default-first-option
            style="width: 100%"
            placeholder="请选择任务所属条线"
            disabled
            @change="handleChangeLx(editTaskForm.rwBmbh, editTaskForm.rwTxlx)"
          >
            <el-option
              v-for="(item, index) in allTxlx"
              :key="index"
              :label="item.value"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="任务类型" prop="rwName" key="3">
          <el-select
            v-model="editTaskForm.rwName"
            filterable
            default-first-option
            style="width: 100%"
            placeholder="请选择任务类型"
            disabled
            @change="
              handleChangeZl(
                editTaskForm.rwName,
                editTaskForm.rwBmbh,
                editTaskForm.rwTxlx
              )
            "
          >
            <el-option
              v-for="(item, index) in lxList"
              :key="index"
              :label="item.value"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-row>
          <el-col :span="14" v-if="this.zlList && this.zlList.length > 0">
            <el-form-item label="子类" prop="rwSun" key="4">
              <el-select
                ref="sun"
                v-model="editTaskForm.rwSun"
                placeholder="请选择子类"
                clearable
                filterable
                style="width: 100%"
                disabled
                class="filter-item"
              >
                <el-option
                  v-for="item in zlList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="标准积分" prop="jf" key="5">
              <el-input-number
                v-model="editTaskForm.jf"
                :min="0"
                :max="99999"
                class="reward-input"
                :disabled="editTaskForm.status != 1 && editTaskForm.status != 2"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="24">
        <el-form-item label="任务标题" prop="title" key="6">
          <el-input
            show-word-limit
            maxlength="100"
            placeholder="请输入任务标题"
            v-model="editTaskForm.title"
            :disabled="editTaskForm.status != 1 && editTaskForm.status != 2"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-row>
          <el-col :span="14">
            <el-form-item label="认领对象" prop="rldx" key="7">
              <el-radio-group
                v-model="form.rldxActive"
                :disabled="editTaskForm.status != 1 && editTaskForm.status != 2"
              >
                <el-radio
                  v-for="item in rldxList"
                  :key="item.value"
                  :label="item.value"
                  >{{ item.label }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <div v-if="form.rldxActive == 1">
              <treeselect
                v-model="editTaskForm.ygbhs"
                placeholder="请选择员工"
                :multiple="true"
                :options="deptUser"
                :disable-branch-nodes="true"
                :show-count="true"
                value-consists-of="LEAF_PRIORITY"
                no-results-text="未搜到任何结果"
                :clear-on-select="true"
                :disabled="editTaskForm.status != 1 && editTaskForm.status != 2"
                :normalizer="normalizer"
                style="width: 100%"
                size="small"
              />
            </div>
            <div v-else-if="form.rldxActive == 2">
              <el-select
                v-model="editTaskForm.bmbhs"
                filterable
                default-first-option
                style="width: 100%"
                :multiple="true"
                placeholder="请选择任务所属部门"
                :disabled="editTaskForm.status != 1 && editTaskForm.status != 2"
                size="small"
              >
                <el-option
                  v-for="(item, index) in allBm"
                  :key="index"
                  :label="item.bmmc"
                  :value="item.bmbh"
                ></el-option>
              </el-select>
            </div>
            <div v-else-if="form.rldxActive == 3">
              <el-select
                v-model="editTaskForm.txlxs"
                filterable
                default-first-option
                style="width: 100%"
                placeholder="请选择任务所属条线"
                size="small"
                :disabled="editTaskForm.status != 1 && editTaskForm.status != 2"
                :multiple="true"
              >
                <el-option
                  v-for="(item, index) in allTxlx"
                  :key="index"
                  :label="item.value"
                  :value="item.key"
                ></el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="24" style="position: relative">
        <span class="star">*</span>
        <el-form-item label="任务说明" prop="rwsm" key="8">
          <span><div id="wangEditor"></div></span>
        </el-form-item>
      </el-col>
      <el-col :span="24" key="9">
        <el-form-item label="预期结果说明">
          <div id="wangEditor2"></div>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-row>
          <el-col :span="14">
            <el-form-item label="任务结束时间" prop="jsrq" key="10">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="editTaskForm.jsrq"
                :picker-options="pickerOptions"
                :clearable="false"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="计划总工时" prop="gs" key="11">
              <el-input-number
                :min="0"
                label="描述文字"
                :disabled="editTaskForm.status != 1 && editTaskForm.status != 2"
                v-model="editTaskForm.gs"
              >
                <template slot="append">.com</template>
              </el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="24">
        <el-row
          v-show="!(editTaskForm.status != 1 && editTaskForm.status != 2)"
        >
          <el-col :span="8">
            <el-form-item label="任务模板附件" key="12">
              <el-upload
                action="#"
                class="upload-demo"
                ref="upload"
                :headers="headers"
                :on-change="handleChange"
                :on-exceed="handleExceed"
                :file-list="fileList"
                :auto-upload="false"
                multiple
                :limit="5"
                :disabled="editTaskForm.status != 1 && editTaskForm.status != 2"
              >
                <el-button type="primary" icon="el-icon-upload" plain
                  >选择附件</el-button
                >
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="16" style="line-height: 40px">
            <div>(单个文件不能超过50M，支持所有扩展名)</div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="24">
        <el-form-item
          :label="
            !(editTaskForm.status != 1 && editTaskForm.status != 2)
              ? ''
              : '任务模板附件'
          "
        >
          <el-table
            :data="editTaskForm.taskFile"
            fit
            highlight-current-row
            :default-sort="{ prop: 'date', order: 'descending' }"
            tooltip-effect="dark"
          >
            <el-table-column
              label="上传人"
              align="left"
              prop="uploader"
              min-width="80px"
              :show-overflow-tooltip="true"
            />
            <el-table-column
              label="上传时间"
              align="left"
              prop="uploadTime"
              min-width="120px"
              :show-overflow-tooltip="true"
            />
            <el-table-column
              label="文件名称"
              align="left"
              prop="fileName"
              min-width="220px"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <el-link @click="openPreview(scope.row)" type="primary">{{
                  scope.row.fileName
                }}</el-link>
              </template>
            </el-table-column>
            <el-table-column
              label="大小"
              align="left"
              prop="fileSize"
              min-width="80px"
              :show-overflow-tooltip="true"
            />

            <el-table-column
              label="操作"
              align="left"
              min-width="100px"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <el-button type="text" @click="handleDownloadFile(scope.row)"
                  >下载</el-button
                >
                <el-button
                  type="text"
                  style="color: #ff0000"
                  @click="handleDeleteFile(scope.row)"
                  :disabled="
                    editTaskForm.status != 1 && editTaskForm.status != 2
                  "
                  >删除</el-button
                >
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="nodata">
                <img src="@/img/nodata.png" alt="" width="160" />
                <div>暂无数据</div>
              </div>
            </template>
          </el-table>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="备注" key="13">
          <el-input
            type="textarea"
            :autosize="{ minRows: 6, maxRows: 6 }"
            maxlength="200"
            show-word-limit
            placeholder="请输入说明"
            v-model="editTaskForm.bz"
            :disabled="editTaskForm.status != 1 && editTaskForm.status != 2"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { formatMomentDate, sizeFormat, checkVal } from "@/utils/utils";
import moment from "moment";
import "moment/locale/zh-cn";
import { mapGetters } from "vuex";
import wangEditor from "wangeditor";
import {
  getBmxxList,
  getKeyValue,
  getTaskZlList,
  getTasklxList,
} from "@/api/taskType.js";
import {
  getEditTask,
  uploadFile,
  deleteFile,
  saveEditTask,
} from "@/api/task.js";
export default {
  components: { Treeselect },
  computed: {
    ...mapGetters(["deptUser", "task"]),
  },
  props: ["mxParams"],
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      form: {
        rldxActive: 1,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      headers: {
        "x-token": localStorage.getItem("token"),
      },
      fileList: [],
      rules: {
        title: [{ required: true, message: "标题不能为空", trigger: "blur" }],
        rwTxlx: [
          {
            required: true,
            message: "任务所属条线不能为空",
            trigger: "change",
          },
        ],
        rwSun: [
          {
            required: true,
            message: "子类不能为空",
            trigger: "change",
          },
        ],

        rwBmbh: [
          {
            required: true,
            message: "帖子所在专栏不能为空",
            trigger: "change",
          },
        ],
        rwName: [
          { required: true, message: "帖子关键词不能为空", trigger: "change" },
        ],
        rldx: [
          { required: true, message: "认领对象不能为空", trigger: "change" },
        ],
        jsrq: [
          {
            required: true,
            message: "任务结束时间不能为空",
            trigger: "change",
          },
        ],
        // content: [{ required: true, message: '帖子内容不能为空', trigger: 'blur' }],
      },
      editTaskForm: {
        rwTxlx: null,
        rwBmbh: null,
        rwName: null,
        rwSun: null,
        id: null,
        typeId: null,
        jf: null,
        title: null,
        rldx: 1,
        ygbhs: null,
        bmbhs: null,
        txlxs: null,
        rwsm: null,
        yqjg: null,
        jsrq: null,
        gs: 0,
        rwmb: null,
        status: null,
        bz: null,
        taskFile: null,
      },
      bmList: [],
      lxList: [],
      jdlxList: [],
      zlList: [],
      ygtxoptions: [],
      rldxList: [
        {
          label: "部门",
          value: 2,
        },
        {
          label: "条线",
          value: 3,
        },
        {
          label: "员工",
          value: 1,
        },
      ],
      allTxlx: [],
      allBm: [],
      parentDialog: false,
    };
  },
  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }

    getBmxxList("1").then((res) => {
      if (res.code == 0) {
        this.bmList = res.data;
      }
    });

    getKeyValue("TXLX", "", "1").then((res) => {
      if (res.code === 0) {
        this.ygtxoptions = res.data;
      }
    });
    getBmxxList("0").then((res) => {
      if (res.code == 0) {
        this.allBm = res.data;
        let temp = [];
        for (let i of this.allBm) {
          temp.push(i.bmbh);
        }
        temp = temp.toString();
        this.allBm.unshift({
          bmbh: temp,
          bmmc: "全部",
        });
      }
    });

    getKeyValue("TXLX", "", "0").then((res) => {
      if (res.code === 0) {
        this.allTxlx = res.data;
      }
    });
    // getJdlxSelector().then((res) => {
    //   if (res.code == 0) {
    //     this.jdlxList = res.data.jdlxList;
    //   }
    // });
    this.getData();
  },
  mounted() {
    let editor = new wangEditor(`#wangEditor`);
    let editor2 = new wangEditor(`#wangEditor2`);

    editor = this.editorConfig(editor);
    editor2 = this.editorConfig(editor2);
    // 创建编辑器
    this.editor = editor;
    this.editor2 = editor2;
  },
  methods: {
    getData() {
      getEditTask(this.mxParams.id).then((res) => {
        if (res.code == 0 && res.data != "ERROR!") {
          this.editTaskForm = res.data;
          this.form.rldxActive = res.data.rldx;
          this.editor.txt.html(this.editTaskForm.rwsm);
          this.editor2.txt.html(this.editTaskForm.yqjg);
          if (this.editTaskForm.status != 1 && this.editTaskForm.status != 2) {
            this.editor.disable();
            this.editor2.disable();
          }
          if (this.editTaskForm.jsrq) {
            this.editTaskForm.jsrq = moment(this.editTaskForm.jsrq);
          }
          this.form.rldxActive = this.editTaskForm.rldx;
          if (this.editTaskForm.ygbhs) {
            this.editTaskForm.ygbhs = this.editTaskForm.ygbhs.split(",");
          } else if (this.editTaskForm.bmbhs) {
            this.editTaskForm.bmbhs = this.editTaskForm.bmbhs.split(",");
          } else if (this.editTaskForm.txlxs) {
            this.editTaskForm.txlxs = this.editTaskForm.txlxs.split(",");
          }
          if (
            this.editTaskForm.taskFile &&
            this.editTaskForm.taskFile.length > 0
          ) {
            for (let i in this.editTaskForm.taskFile) {
              this.editTaskForm.taskFile[i].fileSize = sizeFormat(
                this.editTaskForm.taskFile[i].fileSize
              );
            }
          }
          this.handleChangeZl(
            this.editTaskForm.rwName,
            this.editTaskForm.rwBmbh,
            this.editTaskForm.rwTxlx
          );
          this.handleChangeLx(
            this.editTaskForm.rwBmbh,
            this.editTaskForm.rwTxlx
          );
        }
      });
    },
    handleChangeZl(rwName, rwBmbh, rwTxlx) {
      getTaskZlList(rwName, rwBmbh, rwTxlx).then((res) => {
        if (res.code == 0) {
          this.zlList = res.data;
          this.form.jdlx = null;
          this.form.sun = null;
        }
      });
    },
    handleChangeLx(rwBmbh, rwTxlx) {
      getTasklxList(rwBmbh, rwTxlx).then((res) => {
        if (res.code == 0) {
          this.lxList = res.data;
          this.form.jdlx = null;
          this.form.sun = null;
        }
      });
    },
    editorConfig(editor) {
      editor.config.placeholder = "请输入内容";
      editor.config.height = 300;
      //editor.config.uploadImgShowBase64 = true
      editor.config.uploadImgMaxSize = 10 * 1024 * 1024; //图片大小10M
      editor.config.uploadImgMaxLength = 1;
      editor.config.uploadFileName = "file"; //上传参数 自定义
      editor.config.uploadImgTimeout = 60000; //60s
      editor.config.uploadImgServer = window.g.apiUrl + "/system/uploadPicFile";
      editor.config.uploadImgHeaders = {
        "x-token": localStorage.getItem("token"), // 设置请求头
      };
      editor.config.uploadImgHooks = {
        //监听
        timeout: function (xhr, editor) {
          this.$message.error("上传图片超时！");
        },
        customInsert: function (insertImg, result, editor) {
          if (result.code == 0) {
            var url = result.msg;
            insertImg(url);
          }
        },
      };
      editor.config.excludeMenus = ["video", "link", "code"];
      // 配置 onchange 回调函数，将数据同步到 vue 中
      // editor.config.onchange = function () {
      //   if (editor.txt.html() == "") {
      //     editor.txt.html("&nbsp");
      //   }
      // };

      editor.create();
      return editor;
    },
    saveForm() {
      this.editTaskForm.rwsm = this.editor.txt.html();
      this.editTaskForm.yqjg = this.editor2.txt.html();
      if (!this.editTaskForm.rwTxlx) {
        this.$message.error("请选择任务所属条线！");
      }
      if (!this.editTaskForm.rwBmbh) {
        this.$message.error("请选择任务所属部门！");
      }
      if (!this.editTaskForm.rwName) {
        this.$message.error("请选择任务类型！");
      }
      if (!this.editTaskForm.title) {
        this.$message.error("请输入标题名称！");
        return;
      }
      if (!this.editTaskForm.rwsm || checkVal(this.editTaskForm.rwsm)) {
        this.$message.error("请输入任务说明！");
        return;
      }
      let jsrq = null;
      if (this.editTaskForm.jsrq) {
        jsrq = formatMomentDate(new Date(this.editTaskForm.jsrq));
      }
      let ygbhs = null;
      let bmbhs = null;
      let txlxs = null;
      const { rldxActive } = this.form;
      if (rldxActive == 1 && this.editTaskForm.ygbhs) {
        ygbhs = this.editTaskForm.ygbhs.join(",");
      } else if (rldxActive == 2 && this.editTaskForm.bmbhs) {
        bmbhs = this.editTaskForm.bmbhs.join(",");
      } else if (rldxActive == 3 && this.editTaskForm.txlxs) {
        txlxs = this.editTaskForm.txlxs.join(",");
      }
      if (!ygbhs && !bmbhs && !txlxs) {
        this.$message.error("请选择认领对象");
        return;
      }
      // let rwmb = this.editTaskForm.rwmb;
      // let fileArr = [];
      // if (this.editTaskForm.taskFile && this.editTaskForm.taskFile.length > 0) {
      //   for (let i of this.editTaskForm.taskFile) {
      //     fileArr.push(i.fileId);
      //   }
      // }
      // rwmb = rwmb + "," + fileArr.join(",");
      const params = {
        ...this.editTaskForm,
        rldx: rldxActive,
        jsrq,
        ygbhs,
        bmbhs,
        txlxs,
        taskFile: [],
      };
      saveEditTask(params).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.$store.dispatch(
            "task/fetchTaskListAction",
            this.task.taskList.params
          );
          this.$emit("giveFather", this.parentDialog);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    resetFrom() {
      this.editTaskForm = {
        ...this.editTaskForm,
        ...{
          jf: null,
          title: null,
          rldx: 1,
          ygbhs: null,
          bmbhs: null,
          txlxs: null,
          rwsm: null,
          yqjg: null,
          jsrq: null,
          gs: 0,
          rwmb: null,
          bz: null,
        },
      };
      this.editor.txt.html("");
      this.editor2.txt.html("");
      this.form.rldxActive = 0;
    },
    handleChange(file, fileList) {
      //验证上传文件的格式
      // const suffixReg = /(xls|xlsx|pdf|doc|docx|ppt|pptx)$/;
      // const point = file.name.lastIndexOf(".");
      // const suffix = file.name.substr(point + 1);
      // const isFile = suffixReg.test(suffix);
      // if (!isFile) {
      //   this.$message.error("请上传正确格式的文件 !");
      //   fileList.pop();
      //   return false;
      // }
      // 验证文件大小
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.error(file.name + "文件大小超出限制，请修改后重新上传");
        return false;
      }
      //验证上传文件重复
      // let existFile = fileList
      //   .slice(0, fileList.length - 1)
      //   .find((f) => f.name === file.name);
      // if (existFile) {
      //   this.$message.error("当前文件已经存在!");
      //   fileList.pop();
      //   return false;
      // }
    },
    handleExceed(files, fileList) {
      this.$message.error(
        `当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    submitUpload(status) {
      this.$refs["editTaskForm"].validate((valid) => {
        if (valid) {
          this.$refs.upload.submit();
          let { uploadFiles } = this.$refs.upload;
          let fileLen = uploadFiles.length;
          let form = new FormData();
          uploadFiles.forEach((item, index) => {
            form.append("files", item.raw);
          });

          if (fileLen > 0) {
            //上传文件
            return new Promise((resolve, reject) => {
              uploadFile(form)
                .then((res) => {
                  if (res.code == 0) {
                    this.$message.success("上传成功！");
                  } else {
                    this.$message({
                      type: "error",
                      message: res.msg,
                      showClose: true,
                    });
                  }
                  resolve(res);
                })
                .catch((err) => {
                  reject(err);
                });
            }).then((success) => {
              if (success.code == 0) {
                this.editTaskForm.rwmb =
                  this.editTaskForm.rwmb + "," + success.data;
                this.saveForm(status);
              }
            });
          } else if (fileLen == 0) {
            this.saveForm(status);
          } else {
            this.$message.error(res.msg);
            return false;
          }
        } else {
          this.hiddenDialog(true);
        }
      });
    },
    handleDeleteFile(row) {
      deleteFile({ fileId: row.fileId, path: row.url }).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.getData();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleDownloadFile(row) {
      const filePath = row.url;
      const fileName = row.fileName;
      const url =
        window.g.apiUrl +
        "system/downloadFile?fileName=" +
        fileName +
        "&filePath=" +
        filePath;
      // 组装a标签
      const elink = document.createElement("a");
      // 设置下载文件名
      elink.download = fileName;
      elink.style.display = "none";
      elink.href = url;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },

    giveFather() {
      this.parentDialog = false;
    },
    openPreview(row) {
      const url = row.fileBrowse;
      window.open(url);
    },
  },
};
</script>
<style lang="less" scoped>
.star {
  position: absolute;
  top: 13px;
  color: #f56c6c;
  left: 40px;
}
</style>